import React from "react";
import { Factory, PackageCheck, BadgeCheck, Eye, Ship, LayoutGrid } from "lucide-react";
import { Reveal, SectionHeading, cardBase } from "./primitives";

const VALUES = [
  { icon: Factory, title: "Factory Direct Purchasing", body: "Buy straight from the manufacturer. No intermediaries, no product markups — just factory-direct pricing." },
  { icon: PackageCheck, title: "Large Volume Procurement", body: "Purchase full-container and bulk quantities from a single selected manufacturer with confidence." },
  { icon: BadgeCheck, title: "Verified Manufacturers", body: "Source only from vetted, verified Turkish manufacturers backed by DeMaxtore verification." },
  { icon: Eye, title: "Production Visibility", body: "Track factory capacity, production progress and estimated completion in real time." },
  { icon: Ship, title: "Freight Coordination", body: "Plan inspection, book freight and coordinate shipment without leaving your Workspace." },
  { icon: LayoutGrid, title: "One Workspace", body: "Every document, milestone and conversation for your bulk order in one connected place." },
];

export default function WhyBulk() {
  return (
    <section id="why" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Why BulkContainer™"
            title="Built for high-volume, factory-direct procurement."
            subtitle="The value isn't a marketplace — it's procurement coordination, production visibility and operational control over every bulk order."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`value-card-${i}`}
                className={`${cardBase} group h-full p-7 transition-transform duration-300 hover:-translate-y-1`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#EBF2FF] text-[#0052FF] transition-colors group-hover:bg-[#0052FF] group-hover:text-white">
                  <v.icon className="h-5 w-5" />
                </span>
                <h3 className="font-display mt-5 text-lg font-bold text-[#0A1128]">{v.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-[#64748B]">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
